"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getKSADate = _interopRequireDefault(require("@lumirental/lumi-web-sdk/dist/utils/store/getKSADate"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Check if date passed is today
 * @param {Date} someDate
 * @returns {boolean}
 */
function isToday(someDate) {
  var today = (0, _getKSADate["default"])(new Date()); // convert to ksa time zone
  return someDate.getDate() === today.getDate() && someDate.getMonth() === today.getMonth() && someDate.getFullYear() === today.getFullYear();
}
var _default = exports["default"] = isToday;